import { render, staticRenderFns } from "./clinic-supporting-document-uploader.vue?vue&type=template&id=590fccb5&"
import script from "./clinic-supporting-document-uploader.vue?vue&type=script&lang=js&"
export * from "./clinic-supporting-document-uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports